import React from 'react';

function Icon({ size = 20, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.004 1.25586C14.8356 1.25586 18.754 5.17424 18.754 10.0059C18.754 14.8376 14.8356 18.756 10.004 18.756C5.17229 18.756 1.25391 14.8376 1.25391 10.0059C1.25391 5.17424 5.17229 1.25586 10.004 1.25586ZM8.1869 12.848L6.04467 10.704C5.67971 10.3388 5.67964 9.74331 6.04467 9.37821C6.40979 9.01318 7.00794 9.01546 7.37039 9.37821L8.88065 10.8897L12.6377 7.13264C13.0028 6.76753 13.5983 6.76753 13.9634 7.13264C14.3285 7.49768 14.328 8.09376 13.9634 8.45836L9.54244 12.8793C9.17785 13.2439 8.58176 13.2444 8.21672 12.8793C8.20646 12.869 8.19657 12.8586 8.1869 12.848Z"
        fill="#00BA00"
      />
    </svg>
  );
}

export default Icon;
